

<template>
  <div>
     <ServerError v-if="ServerError"/>
    <v-dialog v-model="dialogBox" max-width="300px">
      <v-card tile>
        <v-layout class="RB" wrap justify-center pa-5 text-center>
          <v-flex xs12> Do you want to Delete this item..? </v-flex>
          <v-flex xs6>
            <v-btn
              text
              :ripple="false"
              color="red"
              @click="deleteFromStock(itemId), (dialogBox = false)"
            >
              Yes</v-btn
            >
          </v-flex>
          <v-flex xs6>
            <v-btn
              text
              :ripple="false"
              color="green"
              @click="dialogBox = false"
            >
              NO</v-btn
            >
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" color="#FEBD08" right>
      <v-layout wrap>
        <v-flex xs11>
          {{ msg }}
        </v-flex>
        <v-flex xs1>
          <v-icon @click="snackbar = !snackbar">mdi-close</v-icon>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-layout wrap px-4>
      <v-flex xs12 py-5>
        <div class="RM clr">SELLER PORTAL</div>
        <div class="head">Stocks</div>
      </v-flex>
      <v-flex xs12 md6>
        <v-radio-group v-model="productStatus">
          <v-layout wrap>
            <v-flex xs4 sm3 class="RB clr">Status </v-flex>
            <v-flex xs4 sm3>
              <v-radio
                class="RB"
                style="padding-bottom: 2%"
                :label="'Active(' + activeCount + ')'"
                value="Active"
                color="green"
              ></v-radio>
            </v-flex>
            <v-flex xs4 sm3>
              <span>
                <v-radio
                  class="RB"
                  style="padding-bottom: 2%"
                  :label="'Inactive(' + inactiveCount + ')'"
                  value="Inactive"
                  color="green"
                >
                </v-radio>
              </span>
            </v-flex>
          </v-layout>
        </v-radio-group>
      </v-flex>
      <v-flex xs12 v-if="stockData.length < 1" py-5>
          <span class="RB"> No Result Found...! </span>
      </v-flex>
      <v-flex v-else xs12 md12 lg11 v-for="(item, i) in stockData" :key="i">
        <v-layout wrap>
          <v-flex xs12 sm6 md5 lg6 style="border-right: 1px dashed grey">
            <v-card flat>
              <v-layout wrap>
                <v-flex xs12 sm2 md2>
                  <v-img v-if="item.photos.length >0"
                    width="80px"
                    height="82px"
                    :src="mediaURL + item.photos[0]"
                  >
                   <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color=" #FDAC53"
                ></v-progress-circular>
              </v-row>
            </template> 
                  </v-img>
                  <v-img v-else
                    width="80px"
                    height="82px"
                    src="../../../assets/images/blankImage.jpg"
                  >
                  </v-img>
                </v-flex>
                <v-flex sm10 md10 pl-sm-5 pl-md-7>
                  <v-layout wrap>
                    <v-flex xs12 class="RM clr">{{ item.productName }}</v-flex>
                    <v-flex xs3 align-self-end>
                      <div class="RM clr medium2" style="padding-top: 10px">
                        Stock
                      </div>
                      <div class="RB">{{ item.stockQuantity }}</div>
                    </v-flex>
                    <v-flex xs3 align-self-end>
                      <div class="RM clr medium2">Price</div>
                      <div class="RB">{{ item.price }}</div>
                    </v-flex>
                    <v-flex xs6 align-self-end class="RM clr">
                      <div class="RM clr medium2">Offer Percentage</div>
                      <div class="RB" style="color: green">
                        {{ item.offer }}%
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md7 lg6 pl-md-5 pl-sm-3 pl-0>
            <v-layout wrap pt-5 pt-sm-0 >
              <v-flex xs5 sm4 md4 lg3 class="medium2 clr">Item added on</v-flex>
              <v-flex xs4 sm4 md5 lg3 class="medium2 clr">Avaliable Stock</v-flex>
              <v-flex xs2 sm4 md3 lg3 text-right >
                <v-radio-group v-model="item.status" style="margin: 0px"
                  ><v-radio
                    style="height: 8px"
                    class="RB"
                    label="Active"
                    value="Active"
                    color="green"
                  ></v-radio></v-radio-group
              ></v-flex>
              
            </v-layout>
            <v-layout>
              <v-flex xs5 sm4 md3 class="RM">
                <span
                  class="RB"
                  v-html="DateFormatted(item.create_date)"
                ></span>
              </v-flex>
              <v-flex xs7 sm8 md6 class="RB" >{{ item.stockQuantity }}</v-flex>
              <v-flex md3 lg3 class="hidden-sm-and-down">
                 <span
                  ><v-btn
                    @click="goToProduct(item._id)"
                    outlined
                    tile
                    dense
                    x-small
                    color="#FAB05A"
                    ><span
                      ><v-icon color="black" small>mdi-pencil</v-icon></span
                    >
                    <span style="color: black">edit</span>
                  </v-btn>
                </span>
                <span style="padding-left: 1px; padding-right: 1px">
                  <v-icon @click="dlt(item._id)"
                    >mdi-delete-outline</v-icon
                  ></span
                >
                <span><v-icon>mdi-dots-vertical</v-icon></span>
              </v-flex>
            </v-layout>
            <v-layout wrap pt-1 pb-7 pb-sm-0 >
              <!-- <v-flex xs3 offset-sm-3 class="hidden-md-and-up">
                <v-btn
                  x-small
                  tile
                  style="text-transform: none; color: white"
                  color="#FFBC6E"
                >
                  <span><v-icon small>mdi-check</v-icon></span>
                  <span>Available </span>
                </v-btn>
              </v-flex> -->
              <v-flex xs6 sm6 md12 text-left class="hidden-md-and-up" >
                <span
                  ><v-btn
                    @click="goToProduct(item._id)"
                    outlined
                    tile
                    dense
                    x-small
                    color="#FAB05A"
                    ><span
                      ><v-icon color="black" small>mdi-pencil</v-icon></span
                    >
                    <span style="color: black">edit</span>
                  </v-btn>
                </span>
                <span style="padding-left: 1px; padding-right: 1px">
                  <v-icon @click="dlt(item._id)"
                    >mdi-delete-outline</v-icon
                  ></span
                >
                <span><v-icon>mdi-dots-vertical</v-icon></span>
              </v-flex>
            </v-layout>
            <v-layout >
              <v-flex xs12 v-if="item.isUpdated == true">
           <span class="RR small" style="color:red">Changes will be updated after verification</span>  
              </v-flex>
              <v-flex xs12 v-if="item.productStatus =='Pending'">
                 <span  class="RR small" style="color:red"> The product is on pending list </span>
              </v-flex>
              <v-flex xs12 v-if="item.productStatus =='Rejected'">
                 <span  class="RR small" style="color:red"> Rejected :<span style="color:black">"{{item.rejectReason}}" </span>   </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 py-5 offset-sm-1>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      ServerError:false,
      itemId: "",
      dialogBox: false,
      snackbar: false,
      msg: "",
      appLoading: false,
      activeCount: "",
      inactiveCount: "",
      stockData: [],
      productStatus: "",
    };
  },
  mounted() {
    this.getData();
  },

  watch: {
    productStatus() {
      this.getData();
    },
  },
  methods: {
    dlt(id) {
      this.dialogBox = true;
      this.itemId = id;
    },
    DateFormatted(params) {
      return params ? moment(params).format("DD-MMMM-Y <br> hh:mm A") : "";
    },
    goToProduct(value) {
      this.$router.push({
        path: "/addproduct",
        query: {
          productId: value,
        },
      });
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "post",
        url: "/my/product/stock",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          status: this.productStatus,
        },
      }).then((response) => {
        if (response.data.status) {
          this.stockData = response.data.data;
          this.activeCount = response.data.activeCount;
          this.inactiveCount = response.data.inactiveCount;
        }
        this.appLoading = false;
      })
      .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    deleteFromStock(value1) {
      axios({
        method: "post",
        url: "/product/delete/" + value1,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status) {
          this.snackbar = true;
          this.msg = "Item Successfully removed";
          this.getData();
        }
      })
      .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
